var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: { id: _vm.id, modalClass: "modal-lg", showCloseButton: true },
    on: { onClose: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _vm.selectedApp
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-md-center w-100",
                    staticStyle: { height: "30px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-md-center",
                        staticStyle: { "min-width": "170px" }
                      },
                      [
                        _c("span", { staticClass: "mr-2" }, [
                          _c(
                            "strong",
                            { staticStyle: { "font-size": "18px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedApp.translate + ".fullname"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                              staticStyle: { width: "30px", height: "30px" },
                              style:
                                "background:" +
                                _vm.$t(_vm.selectedApp.translate + ".bgcolor")
                            },
                            [
                              _c("i", {
                                class: _vm.$t(
                                  _vm.selectedApp.translate + ".icon"
                                ),
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#fff"
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.loading && _vm.hasFeeAnyModule
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center w-100"
                          },
                          [
                            !_vm.device.isMobile
                              ? [
                                  _vm.isFreeTrialLive
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "mr-3 text-success",
                                          staticStyle: { "font-size": "15px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.installapp.message.freetrialdaysleft",
                                                  {
                                                    days: _vm.freeTrialDaysLeft
                                                  }
                                                )
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm.isBeforeEffectDate
                                    ? _c(
                                        "span",
                                        { staticClass: "mr-2 text-success" },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.installapp.message.startchargeapps"
                                                )
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "font-size": "15px" } },
                              [
                                _c(
                                  "span",
                                  {
                                    class: [
                                      (_vm.isFreeTrialLive ||
                                        _vm.isBeforeEffectDate) &&
                                        "text-decoration-line-through"
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.installapp.message.totalprice",
                                            { price: _vm.totalPrice }
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _vm.selectedApp
              ? _c(
                  "div",
                  { staticClass: "container-body" },
                  [
                    _vm.loading
                      ? _c("BaseLoading")
                      : _c("BaseTable", {
                          staticClass: "custom-table",
                          attrs: {
                            tableClass: "table-bordered",
                            hidePagination: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "thead",
                                fn: function() {
                                  return [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "apps.installapp.message.module"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.description")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.installapp.message.pricepermonth"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.installapp.message.installuninstallstatus"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "tbody",
                                fn: function() {
                                  return [
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.availableModules, function(
                                        module,
                                        index
                                      ) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(module.translate)
                                                ) +
                                                "\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            module.learn_more_link
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        module.learn_more_link,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "button.learnmore"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-external-link-alt",
                                                      staticStyle: {
                                                        "font-size": "11px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          module.ignoreRow == null
                                            ? _c(
                                                "td",
                                                {
                                                  class: [
                                                    "text-center",
                                                    _vm.isFreeTrialLive &&
                                                      "text-decoration-line-through"
                                                  ],
                                                  staticStyle: {
                                                    border: "1px solid #dee2e6"
                                                  },
                                                  attrs: {
                                                    rowspan: module.group + 1
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(module.priceText) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          module.ignoreRow == null
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    rowspan: module.group + 1
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column justify-content-center align-items-center"
                                                    },
                                                    [
                                                      _vm.switchDisabledValues[
                                                        index
                                                      ] === true
                                                        ? _c(
                                                            "vs-tooltip",
                                                            {
                                                              staticStyle: {
                                                                float: "right",
                                                                "margin-left":
                                                                  "5px"
                                                              },
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "message.disabledinhrs",
                                                                  {
                                                                    number:
                                                                      _vm
                                                                        .switchDisabledTimeLeftInHrs[
                                                                        index
                                                                      ]
                                                                  }
                                                                ),
                                                                position: "top"
                                                              }
                                                            },
                                                            [
                                                              _c("BaseSwitch", {
                                                                attrs: {
                                                                  value:
                                                                    _vm
                                                                      .switchValues[
                                                                      index
                                                                    ],
                                                                  disabled:
                                                                    _vm
                                                                      .switchDisabledValues[
                                                                      index
                                                                    ] ||
                                                                    _vm.isSubmitting,
                                                                  color:
                                                                    "#A3CA76"
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleCheckBoxValueChange(
                                                                      $event,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : _c("BaseSwitch", {
                                                            attrs: {
                                                              value:
                                                                _vm
                                                                  .switchValues[
                                                                  index
                                                                ],
                                                              disabled:
                                                                _vm
                                                                  .switchDisabledValues[
                                                                  index
                                                                ] ||
                                                                _vm.isSubmitting,
                                                              color: "#A3CA76"
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleCheckBoxValueChange(
                                                                  $event,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          }),
                                                      _vm._v(" "),
                                                      _vm.isFreeTrialLive &&
                                                      module.hasPrice
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-success"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "apps.installapp.message.freetrialdaysleftshort",
                                                                      {
                                                                        days:
                                                                          _vm.freeTrialDaysLeft
                                                                      }
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3641940182
                          )
                        })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _vm.selectedApp
              ? _c("div", { staticClass: "container-footer w-100" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row align-items-center" },
                        [
                          _vm.installedModuleIds.length > 0
                            ? [
                                _vm.maxDisabledUninstallInHrs > 0
                                  ? _c(
                                      "vs-tooltip",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          "margin-left": "5px"
                                        },
                                        attrs: {
                                          text: _vm.$t(
                                            "message.disableduninstallinhrs",
                                            {
                                              number:
                                                _vm.maxDisabledUninstallInHrs
                                            }
                                          ),
                                          position: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-danger",
                                            attrs: {
                                              disabled:
                                                _vm.loading ||
                                                _vm.isSubmitting ||
                                                _vm.maxDisabledUninstallInHrs >
                                                  0,
                                              type: "button"
                                            },
                                            on: { click: _vm.handleUninstall }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.installapp.button.unintallapp"
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger",
                                        attrs: {
                                          disabled:
                                            _vm.loading ||
                                            _vm.isSubmitting ||
                                            _vm.maxDisabledUninstallInHrs > 0,
                                          type: "button"
                                        },
                                        on: { click: _vm.handleUninstall }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.installapp.button.unintallapp"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                              ]
                            : _vm.hasFeeAnyModule
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-md-center" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn no-bg p-0",
                                      attrs: {
                                        href:
                                          "https://www.treesoft.io/th/pricing",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("message.treesoftpricing")
                                          ) +
                                          "\n              "
                                      ),
                                      _c("i", {
                                        staticClass: "fas fa-external-link-alt",
                                        staticStyle: { "font-size": "11px" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row align-items-center",
                          staticStyle: { gap: "10px" }
                        },
                        [
                          _vm.isSubmitting
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-row align-items-center",
                                  staticStyle: { gap: "10px" }
                                },
                                [
                                  _c("CircleProgress", {
                                    attrs: {
                                      percent: _vm.loadingPercent,
                                      size: 25,
                                      viewport: true,
                                      showPercent: false,
                                      borderBgWidth: 3,
                                      borderWidth: 3,
                                      fillColor: "#A3CA76"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.loadingButton) +
                                        "\n            "
                                    )
                                  ])
                                ],
                                1
                              )
                            : [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-light",
                                    attrs: {
                                      disabled: _vm.isSubmitting,
                                      type: "button"
                                    },
                                    on: { click: _vm.handleClose }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("button.cancel")) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-web",
                                    attrs: {
                                      disabled:
                                        _vm.loading ||
                                        _vm.isSubmitting ||
                                        _vm.isAllModulesInactive,
                                      type: "button"
                                    },
                                    on: { click: _vm.handleApply }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.applyButton) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57632898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57632898","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalInstallApp.vue
// module id = null
// module chunks = 